// @flow
import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import Cookies from 'js-cookie'

import { updateLanguage } from '../App/actions'

import './styles.css'

type Props = {
  title: string | { storeName: string },
  dispatch: Function,
  updateHeader: Function,
  updateLanguage: Function,
  user: {
    role: string
  },
  history: {
    push: Function
  }
}

type State = {
  menuOpened: boolean
}

class Header extends Component<Props, State> {
  state = {
    menuOpened: false,
  }
  browserLanguage = (navigator.language || "").indexOf('zh') > -1 ? 'cn' : 'en'
  handleLanguageUpdate = (lang) => {
    this.props.updateLanguage(lang)
    Cookies.set('lang', lang)
  }
  componentDidMount() {
    const selectedLang = Cookies.get('lang')
    this.props.updateLanguage(selectedLang || this.browserLanguage)
    document.addEventListener('mousedown', this.handleClickOutside)
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }
  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        menuOpened: false,
      })
    }
  }
  render() {
    const { title, user } = this.props
    const { menuOpened } = this.state
    const { t } = this.context

    return (
      <div ref={this.setWrapperRef}>
        <div className="header-container">
          <div className={user ? "menu-btn-container" : "menu-btn-container hide"} onClick={() => this.setState({ menuOpened: !menuOpened })}>
            <div className={menuOpened ? "bar1 active" : "bar1"}></div>
            <div className={menuOpened ? "bar2 active" : "bar2"}></div>
            <div className={menuOpened ? "bar3 active" : "bar3"}></div>
          </div>
          <h3 className="header-title">{typeof title !== 'string' ? t("Store Id: {n}", {n: title.storeName}) : t(title)}</h3>
          <div>
            <span onClick={this.handleLanguageUpdate.bind(this, 'en')} className="lang">EN</span> |
            <span onClick={this.handleLanguageUpdate.bind(this, 'cn')} className="lang">中文</span>
          </div>
        </div>
        <div className="header-placeholder" />
        {user && <div className={menuOpened ? "side-menu active" : "side-menu"}>
          <ul className="side-menu-content" onClick={() => this.setState({ menuOpened: !menuOpened })}>
            {(user.role === 'admin' || user.role === 'warehouse') && <li className="side-menu-li"><Link to="/stock-in">{t("Stock In")}</Link></li>}
            {(user.role === 'cs' || user.role === 'admin' || user.role === 'warehouse') && <li className="side-menu-li"><Link to="/unreceived-packages">{t("unreceived packages")}</Link></li>}
            {user.role === 'merchant' && <li className="side-menu-li"><Link to="/merchant">{t("Home")}</Link></li>}
            {(user.role === 'cs' || user.role === 'admin') && <li className="side-menu-li"><Link to="/customer-service/taobao">{t("taobao")}</Link></li>}
            {(user.role === 'cs' || user.role === 'zhongan' || user.role === 'admin') && <li className="side-menu-li"><Link to="/customer-service/zhongan">{t("zhongan")}</Link></li>}
            {(user.role === 'cs' || user.role === 'admin') && <li className="side-menu-li"><Link to="/resell-beta">{t("resell")}</Link></li>}
            {(user.role === 'cs' || user.role === 'admin' || user.role === 'warehouse') && <li className="side-menu-li"><Link to="/staging-records">{t("Staging Records")}</Link></li>}
            {<li className="side-menu-li"><Link to="/change-password">{t("Change password")}</Link></li>}
            <li className="side-menu-li logout-btn" onClick={() => {
              Cookies.remove('axinan-jwt', { domain: '.axinan.com' })
              window.location.reload(false)
            }}>{t('Logout')}</li>
          </ul>
        </div>}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return ({
    lang: state.global.lang,
    parentPath: state.global.parentPath,
    title: state.global.title,
    user: state.global.user
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({
  updateLanguage,
}, dispatch)

Header.contextTypes = {
  t: PropTypes.func
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))



// WEBPACK FOOTER //
// ./src/containers/Header/index.js